export default {
  "content": "<path d=\"M7.043 16.145l3.867-3.938-3.844-3.926L8.461 6.84l3.855 3.926 3.856-3.926 1.394 1.441-3.843 3.926 3.867 3.938-1.395 1.44-3.879-3.948-3.879 3.949-1.394-1.441z\" fill=\"currentColor\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};